/**
 * Constants for the server status component
 * Contains text definitions used as prop defaults in BcsServerStatus.vue
 */

export const SERVER_TEXT_DEFINITIONS = {
  serverUnavailableMessage: {
    title: 'Service Temporarily Unavailable',
    body: 'Our servers are experiencing problems right now, so this page could not load. Your connection is fine — please try again in a few minutes.'
  }
};
